module.exports = __webpack_public_path__ + "media/images/new/camp_protect_educate-20eb3c135025dc5f1d17a8cf039d3cef.jpg";